// export const FINANCIAL_YEAR = [
//   {
//     label: "2022-23",
//     value: "2022-2023",
//   },
//   { label: "2023-24", value: "2023-2024" },
//   { label: "2024-25", value: "2024-2025" },
// ];
export const getFinancialYears = () => {
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth(); // Months are 0-indexed (0 = January, 11 = December)

  // Assuming financial year starts from April (month 3) and ends in March (month 2)
  const financialYearStart = currentMonth >= 3 ? currentYear : currentYear - 1;
  const financialYearEnd = financialYearStart + 1;

  // Generate financial years (current, last two years)
  const financialYears = [];
  for (let i = 0; i < 3; i++) {
    const startYear = financialYearStart - i;
    const endYear = startYear + 1;
    financialYears.push({
      label: `${startYear}-${endYear}`,
      value: `${startYear}-${endYear}`,
    });
  }

  return financialYears;
};

export const FINANCIAL_YEAR = getFinancialYears();
